import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { DialogContent } from '@/components/ui/dialog';
import { AvatarWrapper } from '@/components/ui/avatar';
import { DuelNotification, DuelNotificationButtons, DuelNotificationContent, DuelNotificationName } from '@/components/custom/duel';
import { Button } from '@/components/ui/button';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';

export function DuelsAccept({ duel, setOpen, updateDuelsAndRequests }) {
  const isPlayfulTheme = usePlayfulStudent();
  const client = useClient();

  const handleAcceptDuel = async () => {
    const { error } = await client.mutate(`duels/${duel.id}/accept`, {}, { method: 'PUT' });

    if (error) {
      toast.error('Erro ao aceitar duelo');
    }

    setOpen(false);
    updateDuelsAndRequests();
  };

  const handleRefuseDuel = async () => {
    const { error } = await client.mutate(`duels/${duel.id}/refuse`, {}, { method: 'PUT' });

    if (error) {
      toast.error('Erro ao recusar duelo');
    }

    setOpen(false);
    updateDuelsAndRequests();
  };

  return (
    <DialogContent
      size="sm"
      className="!p-0"
    >
      <DuelNotification className={isPlayfulTheme ? 'bg-mission' : undefined}>
        <AvatarWrapper
          size="md"
          src={duel?.opponent?.image?.url}
          text="Foto do usuário"
        />

        <DuelNotificationContent>
          <DuelNotificationName>{duel?.opponent?.name}</DuelNotificationName>
          <p className="mb-0">te desafiou para um duelo</p>
          <p className="mb-0">Responda antes que o convite expire</p>

          <DuelNotificationButtons>
            {isPlayfulTheme ? (
              <button
                type="button"
                onClick={handleAcceptDuel}
                className="shrink-0 rounded-full px-5 py-2.5 text-sm font-extrabold text-white outline-none transition-transform duration-100 active:translate-y-px"
                style={{ background: 'var(--gradient-btn-continue)', boxShadow: '0 3px 0 var(--color-mission-dark)' }}
              >
                Aceitar
              </button>
            ) : (
              <Button
                variant="outline"
                onClick={handleAcceptDuel}
              >
                Aceitar
              </Button>
            )}
            <Button
              variant="ghost"
              onClick={handleRefuseDuel}
            >
              Recusar
            </Button>
          </DuelNotificationButtons>
        </DuelNotificationContent>
      </DuelNotification>
    </DialogContent>
  );
}
